import { useFilteredOpportunities } from '@/features/opportunities/hooks';
import { useRegisterGAPageView } from '@/hooks';
import { useSearchParams } from 'react-router-dom';

import { useEffect, useMemo } from 'react';
import { OpportunitiesContentHeader } from './header';
import { opportunitiesColumns, OpportunitiesTable } from '../table';
import { getOpportunitiesOrdered } from '@/features/opportunities/helpers';
import { Spinner } from '@/components/ui/spinner';

export function OpportunitiesContent({ onResetFilters }: any) {
  const { opportunities, reload, datasetMaxCapacity, isLoading } = useFilteredOpportunities();
  const [searchParams] = useSearchParams();
  useRegisterGAPageView('Home');

  const orderedOpportunities = useMemo(() => {
    if (!opportunities) return [];
    const opportunitiesWithEnable = opportunities.map((opp) => ({
      ...opp,
      enabled: opp.status.name !== 'closed',
    }));
    return getOpportunitiesOrdered([...opportunitiesWithEnable]);
  }, [opportunities]);

  useEffect(() => {
    reload();
  }, [searchParams, reload]);

  if (isLoading) {
    return (
      <div className="flex h-96 items-center justify-center">
        <Spinner className="text-primary-700 size-10" />
      </div>
    );
  }

  if (!opportunities) return null;

  return (
    <div className="space-y-4">
      <OpportunitiesContentHeader />
      <OpportunitiesTable
        onResetFilters={onResetFilters}
        columns={opportunitiesColumns()}
        data={orderedOpportunities}
        datasetMaxCapacity={datasetMaxCapacity}
      />
    </div>
  );
}
